exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".disclaimer-9d12c829{font-size:10px;line-height:13px;color:#757575}.disclaimer-9d12c829 a,.disclaimer-9d12c829 a:hover,.disclaimer-9d12c829 a:visited,.disclaimer-9d12c829 a:active,.disclaimer-9d12c829 a:focus{color:inherit;text-decoration:none}\n", ""]);

// Exports
exports.locals = {
	"disclaimer": "disclaimer-9d12c829"
};